import React, { useState } from "react";
import { useSelector } from "react-redux";
import { components } from "../components";
import { hooks } from "../hooks";
import { RootState } from "../store";
import {
  setSelectedCategoryType,
  setSelectedMenuCategory,
  setSelectedVegType,
  resetFilters
} from "../store/slices/filterSlice"; // Import Redux actions


export const Filter: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();
  const {menu} = hooks.useGetMenu();
  const [opacity, setOpacity] = useState<number>(0);
 

  const { selectedVegType, selectedCategoryType, selectedMenuCategory } =
    useSelector((state: RootState) => state.filterSlice);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor("#F6F9F9", "#F6F9F9", dispatch);

  const renderHeader = (): JSX.Element => {
    return <components.Header title="Filter" showGoBack={true} />;
  };

  // Veg / Non-Veg Filter
  const renderVegNonVegFilter = (): JSX.Element => {
    return (
      <section style={{ marginBottom: 20 }}>
        <h5 style={{ marginBottom: 14, fontFamily: 'DM Sans, sans-serif', fontSize: 16, fontWeight: 600, color: 'var(--main-color)' }}>Dietary Type</h5>
        <ul style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          {["All", "Veg", "Non-Veg", "Drinks", "Others"].map((type) => {
            const isSelected = selectedVegType === type || (type === "All" && !selectedVegType);
            return (
              <li
                key={type}
                style={{
                  padding: "12px 20px",
                  backgroundColor: isSelected ? "var(--main-turquoise)" : "#f8f9fa",
                  borderRadius: 12,
                  cursor: "pointer",
                  border: isSelected ? 'none' : '1.5px solid #e9ecef',
                  transition: 'all 0.2s ease',
                }}
                onClick={() => dispatch(setSelectedVegType(type === "All" ? "" : type))}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = '#f0f0f0';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }
                }}
              >
                <span
                  style={{
                    fontFamily: 'DM Sans, sans-serif',
                    fontSize: 14,
                    color: isSelected ? "var(--white-color)" : "var(--main-color)",
                    fontWeight: 600,
                    textTransform: "capitalize",
                  }}
                >
                  {type}
                </span>
              </li>
            );
          })}
        </ul>
      </section>
    );
  };

  // "New", "Spicy", "Chef Special" Filters
  const renderCategories = (): JSX.Element => {
    return (
      <section style={{ marginBottom: 30 }}>
        <ul style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {["chef-special"].map((category) => {
            const isSelected = selectedCategoryType === category; // Check if selected
  
            return (
              <li
                key={category}
                style={{
                  padding: "10px 20px",
                  backgroundColor: isSelected ? "var(--main-turquoise)" : "#E9F3F6",
                  borderRadius: 10,
                  cursor: "pointer",
                }}
                onClick={() =>
                  dispatch(setSelectedCategoryType(isSelected ? "" : category)) // Toggle selection
                }
              >
                <span
                  className="t14"
                  style={{
                    color: isSelected ? "var(--white-color)" : "var(--main-color)",
                    textTransform: "capitalize",
                    fontWeight: 500,
                  }}
                >
                  {category}
                </span>
              </li>
            );
          })}
        </ul>
      </section>
    );
  };
  

  // Menu Categories
  const renderMenu = (): JSX.Element => {
    return (
      <section style={{ marginBottom: 30 }}>
        <h5 style={{ marginBottom: 14 }}>Category</h5>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          {menu.map((menuItem) => {
            return (
              <button
                key={menuItem.id}
                style={{
                  padding: "10px 20px",
                  borderRadius: 10,
                  backgroundColor:
                    selectedMenuCategory === menuItem.name
                      ? "var(--main-turquoise)"
                      : "#E9F3F6",
                  cursor: "pointer",
                }}
                onClick={() => dispatch(setSelectedMenuCategory(menuItem.name))}

              >
                <h5
                  style={{
                    color:
                    selectedMenuCategory === menuItem.name
                        ? "var(--white-color)"
                        : "var(--main-color)",
                    fontWeight: 500,
                  }}
                >
                  {menuItem.name}
                </h5>
              </button>
            );
          })}
        </div>
      </section>
    );
  };

  // Apply and Reset Buttons
  const renderButtons = (): JSX.Element => {
    return (
      <section>
        <components.Button
          text="Apply Filters"
          onClick={() => {
            navigate(-1);
          }}
          containerStyle={{ marginBottom: 10 }}
        />
        <components.Button
          text="Reset Filters"
          colorScheme="secondary"
          onClick={() => {
            dispatch(resetFilters());
            if (menu && menu.length > 0) {
              dispatch(setSelectedMenuCategory(menu[0].name));
            }
          }}
        />
      </section>
    );
  };

  // Main Content
  const renderContent = (): JSX.Element => {
    return (
      <main className="scrollable container">
        <section
          style={{
            backgroundColor: "var(--white-color)",
            paddingTop: "10%",
            borderRadius: 10,
            paddingBottom: "10%",
            paddingLeft: 20,
            paddingRight: 20,
          }}
        >
          {renderVegNonVegFilter()} {/* Added Veg / Non-Veg Filter */}
          {renderCategories()} {/* Updated Category Filter */}
          {renderMenu()} {/* Menu Filter */}
          {renderButtons()} {/* Apply & Reset Buttons */}
        </section>
      </main>
    );
  };

  return (
    <div id="screen" style={{ opacity }}>
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
